import { find, forEach, random } from 'lodash';
import { commitLocalUpdate, RecordProxy } from 'relay-runtime';
import { Environment } from 'relay-runtime/lib/store/RelayStoreTypes';

import { FetchKeysStoreKey } from '@lib/reducers/createFetchKeysReducer';

export type Base64String = string;
export type NodeTypeName = FetchKeysStoreKey | 'PatientContact';

export type ResolvedGlobalId = {
  type: NodeTypeName;
  id: string;
};

export function base64(i: string): Base64String {
  return Buffer.from(i, 'ascii').toString('base64');
}

export function unbase64(i: Base64String): string {
  return Buffer.from(i, 'base64').toString('ascii');
}

/**
 * https://github.com/graphql-compose/graphql-compose-relay/blob/master/src/globalId.js
 *
 * Takes a type name and an ID specific to that type name, and returns a
 * "global ID" that is unique among all types.
 */
export function toGlobalId(type: NodeTypeName, id?: string | number): string {
  return id ? base64([type, id].join(':')) : '';
}

export function randomId(type: NodeTypeName) {
  return `client_random:${type.toLowerCase()}:${random(9999)}`;
}

export function isTempRecord(record: RecordProxy) {
  return !!record && /client_random/.test(record.getDataID());
}

/**
 * Takes the "global ID" created by toGlobalID, and returns the type name and ID
 * used to create it.
 */
export function fromGlobalId(globalId: string): ResolvedGlobalId {
  const unbasedGlobalId = unbase64(globalId);
  const delimiterPos = unbasedGlobalId.indexOf(':');
  return {
    type: unbasedGlobalId.substring(0, delimiterPos) as FetchKeysStoreKey,
    id: unbasedGlobalId.substring(delimiterPos + 1),
  };
}

export function getConnectionNode(connectionRecord: RecordProxy, id: string): RecordProxy | undefined {
  if (!connectionRecord || !id) {
    return;
  }
  const edge = find(connectionRecord.getLinkedRecords('edges'), (record) => {
    const node = record && record.getLinkedRecord('node');
    return node ? node.getDataID() === id : false;
  });
  return edge && edge.getLinkedRecord('node');
}

export function invalidateStore(environment: Environment) {
  commitLocalUpdate(environment, (store) =>
    // @ts-ignore
    store.invalidateStore(),
  );
}

export function invalidateConnections(connectionRecords: RecordProxy[]) {
  // @ts-ignore
  forEach(connectionRecords, (record) => record.invalidateRecord());
}

export function invalidateRecord(record?: RecordProxy | null) {
  if (record) {
    // @ts-ignore
    record.invalidateRecord();
  }
}
